import { BaseIcon } from './base-icon.js';
import { svg } from 'lit';

/**
 * Info Icon Component
 * Circle with "i" symbol (outline style)
 * Used for informational messages in alerts and notifications
 */
class InfoIcon extends BaseIcon {
    getSvgAttributes() {
        return {
            xmlns: 'http://www.w3.org/2000/svg',
            viewBox: '0 0 24 24',
            fill: 'none',
            stroke: 'currentColor',
            'stroke-width': '2',
        };
    }

    renderIconPath() {
        return svg`
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
        `;
    }
}

customElements.define('info-icon', InfoIcon);
